<template>
  <div class="px-2">
    <!-- Filtros -->
    <div class="card p-2 mb-2">
      <div class="row g-2">
        <div class="col-md-2">
          <label class="form-label">Empresa vendedora</label>
          <select class="form-control" v-model="filters.empresa">
            <option value="Todas">Todas</option>
            <option v-for="e in empresasVendedoras" :key="e" :value="e">
              {{ e }}
            </option>
          </select>
        </div>
        <div class="col-md-2">
          <label class="form-label">Empresa importadora</label>
          <select class="form-control" v-model="filters.importador">
            <option value="Todas">Todas</option>
            <option v-for="e in empresasImportadoras" :key="e" :value="e">
              {{ e }}
            </option>
          </select>
        </div>
        <div class="col-md-2">
          <label class="form-label">Desde</label>
          <input type="date" class="form-control" v-model="filters.from" />
        </div>
        <div class="col-md-2">
          <label class="form-label">Hasta</label>
          <input type="date" class="form-control" v-model="filters.to" />
        </div>
        <div class="col-md-2 d-flex align-items-end gap-1">
          <button
            class="btn btn-primary w-100"
            :disabled="loading"
            @click="runAndLoad"
          >
            {{ loading ? "Procesando…" : "Procesar" }}
          </button>

          <button
            class="btn btn-success w-100"
            :disabled="loading || exporting || !total"
            @click="exportExcel"
          >
            Exportar
          </button>
        </div>
      </div>
    </div>
    <b-card>
      <!-- Tabla agrupada por empresa vendedora -->
      <div class="table-responsive">
        <table class="table table-bordered table-sm">
          <thead>
            <tr>
              <th style="width: 220px">Empresa Vendedora</th>
              <th>Fecha Emisión</th>
              <th>Código</th>
              <th>Cantidad</th>
              <th>Importador</th>
              <th>Origen Código</th>
            </tr>
          </thead>

          <tbody v-if="!loading && grouped.length">
            <template v-for="(grp, gIndex) in grouped">
              <tr class="table-active" :key="'grp-header-' + gIndex">
                <td colspan="6">
                  <strong>{{ grp.empresa || "—" }}</strong>
                </td>
              </tr>

              <tr
                v-for="row in grp.rows"
                :key="'grp-row-' + gIndex + '-' + row.id"
              >
                <td>{{ row.empresaVendedora }}</td>
                <td>{{ fmtDate(row.fechaEmision) }}</td>
                <td>{{ row.code || "—" }}</td>
                <td>{{ row.cantidadAsignada }}</td>
                <td>{{ row.importador || "—" }}</td>
                <td>{{ row.codeUsed || "—" }}</td>
              </tr>
            </template>
          </tbody>

          <tbody v-else-if="loading">
            <tr>
              <td colspan="6">Cargando…</td>
            </tr>
          </tbody>

          <tbody v-else>
            <tr>
              <td colspan="6">Sin resultados</td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Paginación simple -->
      <div class="d-flex justify-content-between align-items-center">
        <div>Total: {{ total }}</div>
        <div class="d-flex gap-1">
          <button
            class="btn btn-outline-secondary btn-sm"
            :disabled="page <= 1"
            @click="go(page - 1)"
          >
            Anterior
          </button>
          <span class="px-2">Página {{ page }}</span>
          <button
            class="btn btn-outline-secondary btn-sm"
            :disabled="page * size >= total"
            @click="go(page + 1)"
          >
            Siguiente
          </button>
        </div>
      </div>
    </b-card>
  </div>
</template>

<script>
import ReconProcessService from "@/services/ReconProcessService";
import Vue from "vue";
import { BootstrapVue, BootstrapVueIcons, VBTooltip } from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
import * as XLSX from "xlsx";
Vue.use(BootstrapVue);
Vue.use(BootstrapVueIcons);
export default {
  directives: {
    "b-tooltip": VBTooltip,
    Ripple,
  },
  data() {
    return {
      loading: false,
      exporting: false,
      rows: [],
      total: 0,
      page: 1,
      size: 50,

      filters: {
        empresa: "Todas",
        importador: "Todas",
        from: "",
        to: "",
      },

      empresasVendedoras: ["GQR AUTOPARTES S.A.C.", "C&F TRADING S.A.C.", "CIA. IMPORT DE REPUESTOS KONIN S.A.C.", "NIKKEIAUTOS S.A.C."],
      empresasImportadoras: ["C&F TRADING S.A.C.", "CIA. IMPORT DE REPUESTOS KONIN S.A.C.", "GQR AUTOPARTES S.A.C.", "NIKKEIAUTOS S.A.C."],
    };
  },
  computed: {
    grouped() {
      const sorted = [...this.rows].sort((a, b) => {
        const ea = (a.empresaVendedora || "").localeCompare(
          b.empresaVendedora || ""
        );
        if (ea !== 0) return ea;

        const da = a.fechaEmision ? new Date(a.fechaEmision).getTime() : 0;
        const db = b.fechaEmision ? new Date(b.fechaEmision).getTime() : 0;
        return da - db;
      });

      const map = new Map();
      for (const r of sorted) {
        const k = r.empresaVendedora || "—";
        if (!map.has(k)) map.set(k, []);
        map.get(k).push(r);
      }

      return Array.from(map.entries()).map(([empresa, rows]) => ({
        empresa,
        rows,
      }));
    },
  },
  mounted() {
    this.load();
  },
  methods: {
    fmtDate(d) {
      if (!d) return "";
      try {
        return new Date(d).toLocaleDateString();
      } catch {
        return d;
      }
    },
    async runAndLoad() {
      this.loading = true;
      try {
        await ReconProcessService.runMatching(
          {
            from: this.filters.from || undefined,
            to: this.filters.to || undefined,
            empresa: this.filters.empresa,
            importador: this.filters.importador,
          },
          this.$store
        );
      } catch (e) {
        console.warn("runMatching warning", e);
      } finally {
        await this.load();
        this.loading = false;
      }
    },
    async fetchAllRowsForExport() {
      const pageSize = 1000; // tamaño de página solo para exportación
      let page = 1;
      let allRows = [];
      let total = 0;

      while (true) {
        const resp = await ReconProcessService.listAllocations(
          {
            from: this.filters.from || undefined,
            to: this.filters.to || undefined,
            empresa: this.filters.empresa,
            importador: this.filters.importador,
            page,
            size: pageSize,
          },
          this.$store
        );

        const d = resp?.data || {};
        const rows = d.rows || [];
        total = d.total || 0;

        if (!rows.length) break;

        allRows = allRows.concat(rows);

        if (page * pageSize >= total) break;
        page++;
      }

      return allRows;
    },

    async exportExcel() {
      try {
        this.exporting = true;

        const allRows = await this.fetchAllRowsForExport();

        if (!allRows.length) {
          console.warn("No hay datos para exportar");
          this.exporting = false;
          return;
        }

        // Ordenar por empresa vendedora y fecha
        allRows.sort((a, b) => {
          const ea = (a.empresaVendedora || "").localeCompare(
            b.empresaVendedora || ""
          );
          if (ea !== 0) return ea;

          const da = a.fechaEmision ? new Date(a.fechaEmision).getTime() : 0;
          const db = b.fechaEmision ? new Date(b.fechaEmision).getTime() : 0;
          return da - db;
        });

        const header = [
          "EMPRESA VENDEDORA",
          "FECHA EMISIÓN",
          "CÓDIGO",
          "CANTIDAD",
          "IMPORTADOR",
          "ORIGEN CÓDIGO",
        ];

        const data = [];
        data.push(header);

        let currentEmpresa = null;
        const separarPorEmpresa = this.filters.empresa === "Todas";

        for (const r of allRows) {
          const empresa = r.empresaVendedora || "—";

          // Si el filtro es "Todas", mete una fila de título cuando cambia de empresa
          if (separarPorEmpresa && empresa !== currentEmpresa) {
            currentEmpresa = empresa;
            data.push([empresa, "", "", "", "", ""]); // fila de grupo
          }

          data.push([
            empresa,
            r.fechaEmision ? new Date(r.fechaEmision).toLocaleDateString() : "",
            r.code || "",
            r.cantidadAsignada,
            r.importador || "",
            r.codeUsed || "",
          ]);
        }

        const ws = XLSX.utils.aoa_to_sheet(data);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Conciliacion");

        const parts = ["conciliacion"];
        if (this.filters.empresa && this.filters.empresa !== "Todas") {
          parts.push(this.filters.empresa.replace(/\s+/g, "_"));
        }
        if (this.filters.from) parts.push(`desde_${this.filters.from}`);
        if (this.filters.to) parts.push(`hasta_${this.filters.to}`);

        const fileName = parts.join("_") + ".xlsx";

        XLSX.writeFile(wb, fileName);
      } catch (e) {
        console.error("Error exportando Excel", e);
      } finally {
        this.exporting = false;
      }
    },

    async load() {
      this.loading = true;
      try {
        const resp = await ReconProcessService.listAllocations(
          {
            from: this.filters.from || undefined,
            to: this.filters.to || undefined,
            empresa: this.filters.empresa,
            importador: this.filters.importador,
            page: this.page,
            size: this.size,
          },
          this.$store
        );

        const d = resp?.data || {};

        this.rows = d.rows || [];
        this.total = d.total || 0;
        this.page = d.page || this.page;
        this.size = d.size || this.size;
      } catch (e) {
        console.error("Error listando asignaciones", e);
        this.rows = [];
        this.total = 0;
      } finally {
        this.loading = false;
      }
    },
    async go(p) {
      this.page = p;
      await this.load();
    },
  },
};
</script>

<style scoped>
.table-active {
  background: #f6f6f8;
}
.gap-1 > * + * {
  margin-left: 0.5rem;
}
</style>
